import { Type } from '@hugendubel/ws_client';
import { ReducedProduct, ReducedProductResult } from './ReducedProduct';

export class WsBonusShopOrder {
    article: ReducedProduct;
    orderDate: string;
    orderToken: string;

    constructor(article: ReducedProduct, orderDate: string, orderToken: string) {
        this.article = article;
        this.orderDate = orderDate;
        this.orderToken = orderToken;
    }

    static fromApi(json: any): WsBonusShopOrder {
        return new WsBonusShopOrder(
            ReducedProductResult.parse(json.article),
            Type.string(json.orderDate, 'BonusShopOrder.orderDate'),
            Type.string(json.orderToken, 'BonusShopOrder.orderToken')
        );
    }
}
